import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlRadioProps extends ControlTemplateProps {
    
}

export const ControlRadio: React.FC<ControlRadioProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="radio" {...ComponentProps(props)} style={{ ...styles.radio ?? styles.checkbox ?? styles.switch ?? styles.input, ...props.style }} />        
    );
};